// Component to search

// Libraries
import React, { useState, useEffect } from "react";

// import Select from '../dropdown/dropdown';
import Select from "../input/autoComplete";
import { useDispatch } from "react-redux";

import { indexSearch, primarySkillsSearch } from "../../redux/actions/actions";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { components } from "react-select";
// Import data
import { countriesList } from "../../asstes/countries";
import { skillsLists } from "../../asstes/skills";
// Component
function Search({
  onInputChange,
  isNavigate,
  value = "",
  onSearch,
  name = "",
  onInput,
  changeState,
  clearFilter,
  isSearchPage,
  showLoader,
}) {
  const [searchObject, setSearchObject] = useState("");
  const [searchText, setSearchText] = useState("");
  const [suggested, setSuggested] = useState(true);
  const [list, setList] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    var object = localStorage.getItem("searchedObject");
    if (object) object = JSON.parse(localStorage.getItem("searchedObject"));
    var tempObj = object?.map((data) => {
      return {
        label: data.skill || data.label,
        value: data.skill || data.label,
      };
    });
    setSearchObject(object ? tempObj : object);
  }, [localStorage.getItem("searchedObject")]);

  useEffect(() => {
    var countryList = countriesList.map((c) => ({ ...c, label: c.value }));
    var skillList = skillsLists.map((c) => ({ ...c, label: c.value }));
    var lists = [...skillList, ...countryList];
    setList(lists);
  }, []);

  // Search data
  const onChangeEvent = (value, type, action) => {
    if (action?.action === "remove-value" || action?.action === "pop-value") {
      isSearchPage && clearFilter("clearOneSkill", action.removedValue.value);
      setSuggested(type);
      setSearchObject(value);
      // if (name == 'search') {
      //   localStorage.setItem('searchedObject', JSON.stringify(value))
      // }
      var array = value.map((s) => s.label);
      setSearchText(array.toString());
    }
    setSuggested(type);
    setSearchObject(value);
    localStorage.setItem("searchedObject", JSON.stringify(value));

    // if (name == 'search') {
    //   localStorage.setItem('searchedObject', JSON.stringify(value))
    // }
    var array = value.map((s) => s.label);
    setSearchText(array.toString());
  };

  const searchProfiles = (data) => {
    showLoader("start");
    // Replace space with commas
    var text = data.indexOf(" ") >= 0 ? data.replace(/[ ,]+/g, ",") : data;
    var text = text.indexOf(".") >= 0 ? text.replace(/[ .]+/g, ",") : text;
    var textArr = text.indexOf(",") >= 0 ? text.split(",") : [];
    var rawTextArray = data.indexOf(",") >= 0 ? data.split(",") : data;

    if (text || textArr.length) {
      // check if value is skill/industry
      var query = text.replace(/,/gi, "|");
      var finalstr = query[0] === '|' ? query.slice(1) : query;
      finalstr = finalstr.slice(-1) === '|' ? finalstr.slice(0, finalstr.length-1) : finalstr;
      // localStorage.setItem('searchedObject', JSON.stringify(searchObject));
      localStorage.setItem("inputField", JSON.stringify(suggested));
      dispatch(primarySkillsSearch(finalstr))
        .then((res) => {
          localStorage.removeItem("searchedItem");
          if (res.length > 0) {
            localStorage.setItem(
              "searchedItem",
              `Skills:${rawTextArray.length > 0 ? rawTextArray : text}`
            );
            changeState(name ? "" : "/search");
          } else {
            const concatinatedWithOrignalStr = `${finalstr}|${data}`
            dispatch(indexSearch(concatinatedWithOrignalStr)).then((res) => {
              localStorage.setItem(
                "searchedItem",
                `Filters:${rawTextArray.length > 0 ? rawTextArray : text}`
              );
              changeState(name ? "" : "/search");
            });
          }
        })
        .catch(() => {
          console.log("Error");
        });
    }
    setTimeout(() => {
      showLoader("end");
    }, 3000);
  };

  const icon = (
    <SearchRoundedIcon
      color="action"
      fontSize="large"
      style={{ paddingLeft: "10px" }}
    />
  );
  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      {" "}
      {icon} {children}
    </components.Control>
  );

  // Return
  return (
    // Render fields
    <div className="flex col-span-12 grid grid-cols-12 gap-3 ">
      {/* Add input */}
      <div className="col-span-12">
        <Select
          className="rounded-md"
          name="search"
          value={searchObject}
          search={true}
          suggested={suggested}
          onSearch={searchProfiles}
          placeholder={`🔍 Try “Android”, “Javascript” or “Agile”`}
          getChange={onChangeEvent}
          options={list}
          clearFilter={clearFilter}
          isSearchPage={isSearchPage}
          autoFocus={true}
          // components = {{ Control}}
        />
        {/* <InputSearch placeholder='Search...' onInputChange={onInputChange} value={value} onSearch={onSearch} name={name} /> */}
        {/* <Input placeholder='Search...' onInputChange={onInputChange} value={value} onSearch={onSearch} name={name}/> */}
      </div>
    </div>
  );
}

// Export the Component
export default Search;
